import { boolean, object, string } from 'yup';
import { TFunction } from 'i18next';

import { requiredDateDdMmYyyyField, requiredString } from 'common/validation';

export function makeAgreementsSchema(t: TFunction) {
  return object().shape({
    hazardAgreements: boolean().oneOf([true], t('form.required')),
    statement: object()
      .required()
      .default(null)
      .nullable()
      .shape({
        a: boolean().oneOf([true], t('form.required')),
        b: boolean().oneOf([true], t('form.required')),
        c: boolean().oneOf([true], t('form.required')),
        d: boolean().oneOf([true], t('form.required')),
        e: boolean().oneOf([true], t('form.required')),
        f: boolean().oneOf([true], t('form.required')),
        g: boolean().oneOf([true], t('form.required')),
        h: boolean().oneOf([true], t('form.required')),
      }),
    dateOfSignature: requiredDateDdMmYyyyField(t),
    placeOfSignature: requiredString(t),
    interviewTime: requiredString(t),
  });
}
